import { Typography } from '@/shared';
import { pushSlug } from '@/shared/helpers/url';
import { ProjectsStoryblok } from '@/shared/types/storyblok/storyblok-types';
import clsx from 'clsx';
import styles from '../ProjectListing.module.scss';
import { SBImage } from '@/components/ImageService/SBImage';

interface SingleCardProps {
    content: ProjectsStoryblok[];
    isMobile: boolean;
}

const SingleCard: React.FC<SingleCardProps> = ({ content, isMobile }) => {
    const padding = isMobile ? { paddingRight: '20px' } : { paddingRight: '0px' };

    if (!Array.isArray(content) || content.length === 0 || !content[0].content) {
        return null;
    }
    return (
        <div className={styles.singleCard} onClick={() => pushSlug(content[0].full_slug)} style={padding}>
            {content[0].content.mainImage?.filename && (
                <SBImage image={content[0].content.mainImage} height={256} fit="cover" />
            )}
            <div className={styles.infos}>
                <div className={clsx({ [styles.space]: !content[0].content.productName })}>
                    <Typography.Small className={styles.preTitle}>{content[0].content.productName}</Typography.Small>
                </div>
                <Typography.H3 className={styles.title}>{content[0].content.title}</Typography.H3>
            </div>
        </div>
    );
};

export default SingleCard;
